import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { StreamDefinition } from '../../signalr/types'
import { getBenchmarkDataSuccess } from './actions'
import type { BenchmarkInfo } from './types'

export const fetchBenchmarkDataDefinition: StreamDefinition<
  [],
  BenchmarkInfo,
  Action
> = {
  method: 'GetBenchmarkData',
  strategy: 'switch',
  getParams,
  mapResponse: getBenchmarkDataSuccess,
  errorAction: 'benchmarkdata.fetchFail',
  cancelOn: ['benchmarkdata.fetchCancel']
}
